import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import echarts from 'echarts';
@Component({
  selector: 'icc-trend-wechat-indicator',
  templateUrl: './icc-trend-wechat-indicator.component.html',
  styleUrls: ['./icc-trend-wechat-indicator.component.less'],
})
export class IccTrendWechatIndicatorComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}
  // 图谱实例
  chartIns: any;
  // 数据源
  @Input() title: string;
  @Input() data: Array<{
    date: string;
    pageView: number; // 阅读次数
    share: number; // 分享次数
    transpond: number; // 转发次数
  }>;

  dateList: Array<string>;
  pageViewList: Array<number>;
  shareList: Array<number>;
  transpondList: Array<number>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    if (this.data instanceof Array) {
      setTimeout(() => {
        this.formatData();
        this.createLineChart('chart-el');
      }, 100);
    }
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  /* 处理数据源 */
  formatData() {
    const dateList = [];
    const pageViewList = [];
    const shareList = [];
    const transpondList = [];
    const lineItemLable = {
      show: true,
      color: 'rgb(63,63,63)',
      formatter: item => {
        return item.value;
      },
    };
    this.data.forEach(item => {
      dateList.push(item.date);
      pageViewList.push({
        value: item.pageView,
        label: lineItemLable,
      });
      shareList.push({
        value: item.share,
        label: lineItemLable,
      });
      transpondList.push({
        value: item.transpond,
        label: lineItemLable,
      });
    });
    this.dateList = dateList;
    this.pageViewList = pageViewList;
    this.shareList = shareList;
    this.transpondList = transpondList;
  }
  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const legendNames = ['阅读次数', '分享次数', '收藏次数'];
    const axisLabel: any = {
      textStyle: {
        color: '#333',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.data.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 60;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        data: legendNames,
        itemHeight: 10,
        itemGap: 40,
        textStyle: {
          color: '#B4B4B4',
        },
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.dateList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel,
        },
      ],
      yAxis: [
        {
          name: '单位:次',
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B4B4B4',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B4B4B4',
            },
            formatter: '{value} ',
          },
        },
        {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
        },
      ],
      series: [
        {
          name: legendNames[0],
          type: 'line',
          symbolSize: 1,
          itemStyle: {
            normal: {
              color: 'rgb(87,179,255)',
            },
          },
          data: this.pageViewList,
        },
        {
          name: legendNames[1],
          type: 'line',
          symbolSize: 1,
          itemStyle: {
            normal: {
              color: 'rgb(0,206,158)',
            },
          },
          data: this.shareList,
        },
        {
          name: legendNames[2],
          type: 'line',
          symbolSize: 1,
          itemStyle: {
            normal: {
              color: 'rgb(250,187,20)',
            },
          },
          data: this.transpondList,
        },
      ],
    });
  }
}
